export default function toArray(collection) {
  return Array.prototype.slice.call(collection);
}
